import React from 'react';
import { Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';
import { GetDashboardPreference_vm_profile_dashboardPreference_dashboardComponents as IComponent } from './dashboard-widget-setting/__generated__/GetDashboardPreference';
import { ChartWidget } from './widgets/ChartWidget';
import { NumberWidget } from './widgets/number-widget/NumberWidget';
import { ChartWidget as IChartWidget } from './dashboard-widget-setting/__generated__/ChartWidget';
import { NumberWidget as INumberWidget } from './dashboard-widget-setting/__generated__/NumberWidget';
// import { RequiringActionWidget as IRequiringActionWidget } from './dashboard-widget-setting/__generated__/RequiringActionWidget';
import { PwiWidget } from './widgets/pwi-widget/PwiWidget';
// import { RequiringActionWidget } from './widgets/requiring-action-widget/RequiringActionWidget';
import { ChartNumberWidget as IChartNumberWidget } from './dashboard-widget-setting/__generated__/ChartNumberWidget';
import { ChartNumberWidget } from './widgets/number-chart-widget/NumberChartWidget';
import { TableWidget } from './widgets/table-widget/TableWidget';
import { TableWidget as ITableWidget } from './dashboard-widget-setting/__generated__/TableWidget';
import { RequiringActionWidget } from './widgets/requiring-action-widget/RequiringActionWidget';
import { RequiringActionWidget as IRequiringActionWidget } from './dashboard-widget-setting/__generated__/RequiringActionWidget';

interface WidgetItemProps {
  component: IComponent;
  onDelete: (dashboardComponentId: string) => void;
  onEdit: (dashboardComponent: IComponent) => void;
  canEdit?: boolean;
}

export function WidgetItem({ component, onDelete, onEdit, canEdit = true }: WidgetItemProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const { theme } = useCampfireTheme();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDeleteHandler = () => {
    onDelete(component.dashboardComponentId);
    handleClose();
  };

  const onEditHandler = () => {
    onEdit(component);
    handleClose();
  };

  const widget = React.useMemo(() => {
    return component.widget;
  }, [component]);

  return (
    <Box
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {canEdit && (
        <>
          <IconButton
            size='small'
            onClick={handleClick}
            aria-label='Widget options'
            style={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 1,
              padding: '4px',
              border: `1px solid ${theme.color.grey.neutral200}`,
              borderRadius: '4px',
              backgroundColor: 'white',
            }}
          >
            <MoreVert style={{ fontSize: '20px', color: theme.color.grey.neutral300 }} />
          </IconButton>
          <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem onClick={onEditHandler}>Edit</MenuItem>
            <MenuItem onClick={onDeleteHandler}>Delete</MenuItem>
          </Menu>
        </>
      )}
      {component.widget.__typename === 'VOLUNTEER_ChartWidgetType' && (
        <ChartWidget widget={component.widget as IChartWidget} showHighlight={component.position.colSpan > 1} />
      )}
      {component.widget.__typename === 'VOLUNTEER_NumberWidgetType' && (
        <NumberWidget widget={widget as INumberWidget} />
      )}
      {component.widget.__typename === 'VOLUNTEER_ChartNumberWidgetType' && (
        <ChartNumberWidget widget={widget as IChartNumberWidget} />
      )}
      {component.widget.__typename === 'VOLUNTEER_TableWidgetType' && <TableWidget widget={widget as ITableWidget} />}
      {component.widget.__typename === 'VOLUNTEER_PwiWidgetType' && <PwiWidget widget={component.widget} />}
      {component.widget.__typename === 'VOLUNTEER_RequiringActionWidgetType' && (
        <RequiringActionWidget widget={widget as IRequiringActionWidget} />
      )}
    </Box>
  );
}
